import { createContext, useContext, useReducer } from "react";
import axios from "axios";
import {
  GET_CAST_BEGIN,
  GET_CAST_ERROR,
  GET_CAST_SUCCESS,
  GET_CITY_BEGIN,
  GET_CITY_ERROR,
  GET_CITY_SUCCESS,
  GET_COUNTY_BEGIN,
  GET_COUNTY_ERROR,
  GET_COUNTY_SUCCESS,
  GET_FILTER_MARITIALSTATUS_BEGIN,
  GET_FILTER_MARITIALSTATUS_ERROR,
  GET_FILTER_MARITIALSTATUS_SUCCESS,
  GET_MARITIALSTATUS_BEGIN,
  GET_MARITIALSTATUS_ERROR,
  GET_MARITIALSTATUS_SUCCESS,
  GET_RELIGION_BEGIN,
  GET_RELIGION_ERROR,
  GET_RELIGION_SUCCESS,
  GET_STATE_BEGIN,
  GET_STATE_ERROR,
  GET_STATE_SUCCESS,
} from "../utils/action";
import {
  ACCEPT_HEADER,
  get_caste_url,
  get_city_url,
  get_country_url,
  get_maritialstatus_url,
  get_merital_status_url,
  get_religion_url,
  get_state_url,
} from "../utils/constant.js";
import Basic_reducer from "../reducer/Basic_reducer.js";
import { useLoginContext } from "../context/Login_context.js";

const BasicContext = createContext();

const initialState = {
  cast_loading: false,
  cast_data: [],
  coutry_loading: false,
  country_data: [],
  state_loading: false,
  state_data: [],
  city_loading: false,
  city_data: [],
  religion_loading: false,
  religion_data: [],
  maritialstatus_loading: false,
  maritialstatus_data: [],
  filterMaritialstatus_loading: false,
  filterMaritialstatus_data: [],
};

const getToken = () => localStorage.getItem("token");

export const BasicProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Basic_reducer, initialState);
  const { setLogout } = useLoginContext();

  const GetCasteApi = () => {
    const token = getToken();
    dispatch({ type: GET_CAST_BEGIN });

    axios
      .get(get_caste_url, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.status === "success") {
          dispatch({ type: GET_CAST_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_CAST_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Caste Api ", err);
        dispatch({ type: GET_CAST_ERROR });
      });
  };

  const GetCountryApi = () => {
    const token = getToken();
    dispatch({ type: GET_COUNTY_BEGIN });

    axios
      .get(get_country_url, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.success === 1) {
          dispatch({ type: GET_COUNTY_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_COUNTY_ERROR });
        }
      })
      .catch((err) => {
        console.log("error in Country api ", err);
        dispatch({ type: GET_COUNTY_ERROR });
      });
  };

  const GetStateApi = (params) => {
    const token = getToken();
    dispatch({ type: GET_STATE_BEGIN });

    return axios // ← return ઉમેરો
      .post(get_state_url, params, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.success === 1 || res.data.status === "success") {
          dispatch({ type: GET_STATE_SUCCESS, payload: res.data.data });
          return res.data.data; // ← data return
        } else {
          dispatch({ type: GET_STATE_ERROR });
        }
      })
      .catch((err) => {
        console.log("error in State api ", err);
        dispatch({ type: GET_STATE_ERROR });
      });
  };

  const GetCityApi = (params) => {
    const token = getToken();
    dispatch({ type: GET_CITY_BEGIN });

    return axios // ← return ઉમેરો
      .post(get_city_url, params, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.success === 1 || res.data.status === "success") {
          dispatch({ type: GET_CITY_SUCCESS, payload: res.data.data });
          return res.data.data; // ← data return
        } else {
          dispatch({ type: GET_CITY_ERROR });
        }
      })
      .catch((err) => {
        console.log("error in City api ", err);
        dispatch({ type: GET_CITY_ERROR });
      });
  };

  const GetReligionApi = () => {
    const token = getToken();
    dispatch({ type: GET_RELIGION_BEGIN });

    axios
      .get(get_religion_url, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.status === "success") {
          dispatch({ type: GET_RELIGION_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_RELIGION_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get religion Api ", err);
        dispatch({ type: GET_RELIGION_ERROR });
      });
  };

  const GetMaritalStatusApi = () => {
    const token = getToken();
    dispatch({ type: GET_MARITIALSTATUS_BEGIN });

    axios
      .get(get_maritialstatus_url, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.status === "success") {
          dispatch({
            type: GET_MARITIALSTATUS_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_MARITIALSTATUS_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get merital Status Api ", err);
        dispatch({ type: GET_MARITIALSTATUS_ERROR });
      });
  };

  const GetMaritalStatusDashFilterApi = () => {
    const token = getToken();
    dispatch({ type: GET_FILTER_MARITIALSTATUS_BEGIN });

    axios
      .get(get_merital_status_url, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.status === "success") {
          dispatch({
            type: GET_FILTER_MARITIALSTATUS_SUCCESS,
            payload: res.data.data,
          });
        } else {
          dispatch({ type: GET_FILTER_MARITIALSTATUS_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get merital Status Api ", err);
        dispatch({ type: GET_FILTER_MARITIALSTATUS_ERROR });
      });
  };

  return (
    <BasicContext.Provider
      value={{
        ...state,
        GetCasteApi,
        GetCountryApi,
        GetStateApi,
        GetCityApi,
        GetReligionApi,
        GetMaritalStatusApi,
        GetMaritalStatusDashFilterApi,
      }}
    >
      {children}
    </BasicContext.Provider>
  );
};

export const useBasicContext = () => {
  return useContext(BasicContext);
};
